import api from '../API';
import { Config } from '../types';

export function update(id: string, config: Config): Promise<void> {
  return api.put(`accounts/${id}/config`, { config });
}
